import { Component, OnInit } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import { ActivatedRoute } from '@angular/router';
import { UsersService } from '@app/shared/services/users.service';
import { AlertService } from '@app/shared/services/alert.service';
import { ReservationsService } from '@app/shared/services/reservations.service';
import * as moment from 'moment/moment';
import { SessionService } from '@app/shared/services/session.service';
import { PhotoService } from '@app/shared/services/photo.service';
import { DateService } from '@app/shared/services/date.service';

@Component({
    selector: 'app-user-informations',
    templateUrl: './user-informations.component.html',
    styleUrls: ['./user-informations.component.scss']
})
export class UserInformationsComponent implements OnInit {

    public sessionStatusNames: Array<string> = ['Réservé', 'En cours', 'Terminé'];
    public currentPage: number = 1;
    public maxPages: number = 1;
    public loadingStatus: boolean = true;
    public noResult: boolean = false;

    public id: string = '0';
    public user: any = {};
    public reservations: any = [];
    public loading: boolean = true;
    public loadingPhoto: boolean = false;
    public password: string = '********';
    public creditCard: string = '';
    public staff: boolean = false;

    public routerURL: string = '/user/list';
    public previousUrlName: string = 'Liste des utilisateurs'

    public idCard: Array<any> = [];
    public idCardMissing: boolean = false;
    public societies: Array<any> = ["interne", 'externe'];

    public comments: any = [
        {
            message: "utilisateur bloqué car probleme de paiement",
            date: "2019-01-01 12:00:00",
        },
        {
            message: "utilisateur bloqué car probleme de paiement",
            date: "2019-01-01 12:00:00",
        },
        {
            message: "utilisateur desinscrit car irrespect des regles",
            date: "2022-10-04 18:00:00",
        },
    ];

    public comment: string = "";

    public drivingLicense: Array<any> = [];
    public drivingLicenseMissing: boolean = false;

    // public multiCode: Array<any> = ["BOUNS", "MOD-PIC", "MODULAUTO", "VOP", "VOP-PIC", "VOP-F", "NEWSOCIETY-VOP", "VOP-TROPEZ", "VOP-NEUBAUER"];

    public multiCode: Array<any> = [{ name: "BOUNS", type: 0 }, { name: "MOD-PIC", type: 1 }, { name: "MODULAUTO", type: 1 }, { name: "VOP", type: 0 }];

    public codeType: number = 0;
    public code: String = '';
    public editPassword: boolean = false;
    public passwordcreate: String = '';

    public rectoPermi: any = '';
    public versoPermi: any = '';

    public rectoCard: any = '';
    public versoCard: any = '';

    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private route: ActivatedRoute,
        private userService: UsersService,
        private reservationService: ReservationsService,
        private alertService: AlertService,
        public session: SessionService,
        public photoService: PhotoService,
        private dateService: DateService
    ) { }

    ngOnInit() {
        this.route.queryParams
            .subscribe(params => {
                if (params.from) this.routerURL = params.from;
                if (params.name) this.previousUrlName = params.name;
            });


        this.id = this.route.snapshot.paramMap.get('id') || '385';
        this.titleService.setTitle(`Information sur l'utilisateur / VOP`);
        this.menu.setMenuState('user', 'user', 'information');
        this.menu.id = this.id;

        this.loadInformations();
    }

    removeCode(code) {
        const index = this.multiCode.indexOf(code.toUpperCase());
        if (index > -1) {
            this.multiCode.splice(index, 1);
        }
    }

    addCode(code) {
        console.log("add code", code, this.codeType);

        if (code == "") {
            this.alertService.error(`impossible d'ajouter un code vide`);
        }
        else if (this.multiCode.indexOf(code.toUpperCase()) === -1) {
            this.multiCode.push({
                name: code.toUpperCase(),
                type: this.codeType
            });
            // this.alertService.alert("Le code a bien été ajouté.");
            this.code = ""

            this.alertService.alert(`Le code <font color="F7A72A">"${code}"</font> a été ajouter en <font color="F7A72A">${this.societies[this.codeType]}</font>`);
        }
        else {
            this.alertService.alert(`Le code <font color="FF0000">"${code}"</font> est déjà présent dans la liste.`);
        }
    }

    generatePassword() {
        let chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        let passwordLength = 7;
        let password = "";

        for (var i = 0; i <= passwordLength; i++) {
            var randomNumber = Math.floor(Math.random() * chars.length);
            password += chars.substring(randomNumber, randomNumber + 1);
        }

        console.log("password generate:", password);
        this.passwordcreate = password;
    }

    updatePassword() {
        if (this.editPassword) {
            console.log("Update password")
        }
        else {
            this.passwordcreate = "";
        }

        this.editPassword = !this.editPassword
    }

    loadInformations(): void {
        this.getReservationsHistory(1);
        this.userService.getUser(this.id).then((res) => {
            res = this.dateService.convertToLocal(res);
            this.user = res;
            if (this.user.Last4 && this.user.Last4.length > 0) {
                this.creditCard = `**** **** **** ${this.user.Last4}`;
            } else {
                this.creditCard = `Non renseigné`;
            }
            this.loading = false;
        });
        this.userService.getUserIDCard(this.id).then((res) => {
            console.log("userCard", res)

            try {
                this.photoService.setFile(res[0].file, 'image/png').then(async (file) => {
                    console.log("file", file);
                    this.rectoCard = await this.blobToBase64(file)

                    // this.photoService.downloadFile(file, this.drivingLicense[0].filename);
                });
            } catch (error) {
                this.rectoCard = "../../../assets/icons/status/Annule_mais_due.svg";
            }

            try {
                this.photoService.setFile(res[1].file, 'image/png').then(async (file) => {
                    console.log("file", file);
                    this.versoCard = await this.blobToBase64(file)

                    // this.photoService.downloadFile(file, this.drivingLicense[0].filename);
                });
            } catch (error) {
                this.versoCard = "../../../assets/icons/status/Annule_mais_due.svg";
            }

            if (res && res.length === 0) {
                this.idCardMissing = true;
            }
            this.idCard = res;
        });
        this.userService.getUserDrivingLicense(this.id).then((res) => {
            console.log("driving licence:", res)

            try {
                this.photoService.setFile(res[0].file, 'image/png').then(async (file) => {
                    console.log("file", file);
                    this.rectoPermi = await this.blobToBase64(file)

                    // this.photoService.downloadFile(file, this.drivingLicense[0].filename);
                });
            } catch (error) {
                this.rectoPermi = "../../../assets/icons/status/Annule_mais_due.svg";
            }

            try {
                this.photoService.setFile(res[1].file, 'image/png').then(async (file) => {
                    console.log("file", file);
                    this.versoPermi = await this.blobToBase64(file)

                    // this.photoService.downloadFile(file, this.drivingLicense[0].filename);
                });
            } catch (error) {
                this.versoPermi = "../../../assets/icons/status/Annule_mais_due.svg";
            }


            if (res && res.length === 0) {
                this.drivingLicenseMissing = true;
            }
            console.log("drivingLicenseMissing", res)
            this.drivingLicense = res;
        });
    }

    blobToBase64(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }

    getReservationsHistory(page) {
        let start = moment().subtract(6, 'months').format().split('T')[0];
        let end = moment().add(14, 'days').format().split('T')[0];

        this.currentPage = page;
        this.noResult = false;
        this.loadingStatus = true;
        this.reservationService.updateReservationCount(start, end, 0, parseInt(this.id, 10)).then(() => {
            this.maxPages = this.reservationService.maxPages;
            this.reservationService.updateReservationByUser(parseInt(this.id, 10), start, end, page).then((res) => {
                if (res && res.length === 0) {
                    this.noResult = true;
                    this.loadingStatus = false;
                }
                res = this.dateService.convertAlltoLocal(res);
                this.reservations = res;
                this.reservations.forEach((reservation) => {
                    this.reservationService.getReservationInvoiceFields(reservation.Id).then((res) => {
                        reservation.totalAmount = 0;
                        if (res && res.length > 0) {
                            res.forEach((line) => {
                                reservation.totalAmount += line.IncludingTaxes * line.Quantity;
                            });
                        }
                        this.loadingStatus = false;
                    });
                });
            });
        });
    }

    getDrivingLicense(face) {
        if (face === 'recto') {
            this.photoService.setFile(this.drivingLicense[0].file, 'image/png').then((file) => {
                this.photoService.downloadFile(file, this.drivingLicense[0].filename);
            });
        }
        if (face === 'verso') {
            this.photoService.setFile(this.drivingLicense[1].file, 'image/png').then((file) => {
                this.photoService.downloadFile(file, this.drivingLicense[1].filename);
            });
        }
    }

    getIDCard(face) {
        if (face === 'recto') {
            this.photoService.setFile(this.idCard[0].file, 'image/png').then((file) => {
                this.photoService.downloadFile(file, this.idCard[0].filename);
            });
        }
        if (face === 'verso') {
            this.photoService.setFile(this.idCard[1].file, 'image/png').then((file) => {
                this.photoService.downloadFile(file, this.idCard[1].filename);
            });
        }
    }

    modifyPhoto(): void {
        this.photoService.askFile().then((photo) => {
            this.photoService.modifyUserPhoto(parseInt(this.id, 10), photo).then((res) => {
                if (!res || res.Success === false)
                    return this.alertService.alert("Une erreur est survenue lors du changement de la photo.");
                this.loadingPhoto = true;
                this.userService.getUser(this.id).then((res) => {
                    this.user.ProfilePicture = res.ProfilePicture;
                    this.loadingPhoto = false;
                });
            });
        });
    }

    updateUser() {
        this.userService.updateUser(this.user).then(() => {
            this.alertService.alert("Les modifications ont été effectuées.");
            sessionStorage.removeItem('UserList')
        });
    }

    activateUser(action) {
        this.userService.activateUser(parseInt(this.id, 10), action).then(() => {
            this.loadInformations();
            this.alertService.alert((action === true) ? `L'utilisateur est désormais activé.` : `L'utilisateur est désormais désactivé.`);
            sessionStorage.removeItem('UserList')
        })
    }

    addComment() {
        if (this.comment) {
            this.comments.push({
                message: this.comment,
                date: moment().format(),
            })
            this.comment = '';
        }
    }
}
